export const sortObjectByKey = (obj: Record<string, unknown>) => {
  return Object.keys(obj)
    .sort()
    .reduce(
      (sortedObj, key) => {
        sortedObj[key] = obj[key];
        return sortedObj;
      },
      {} as Record<string, unknown>,
    );
};
